module.exports = __webpack_public_path__ + "img/11csm_Ersa-Wave-02-900x600_902471f23d.f431b8a9.jpg";